import React, { useEffect, useState } from "react";
import DataTable from "@/components/ui/DataTable";
import { columns } from "./columns";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { useCurrentUser } from "@/context/UserContext";
import { fetchLeaveRequests, fetchLeaveRequestsOfUser } from "@/features/leaveRequests/leaveRequestSlice";
import { selectUserLeaveRequests } from "@/features/leaveRequests/leaveRequestSelector";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";


function StaffLeaveRequestCard() {
  const { currentUser } = useCurrentUser();
  const [currentPage, setCurrentPage] = useState(1);


  const dispatch = useAppDispatch();
  const { requests, pagination } = useAppSelector(selectUserLeaveRequests);
  useEffect(() => {
    if (!currentUser) return;
    dispatch(fetchLeaveRequestsOfUser({ userId: currentUser?.id, page: currentPage }));
  }, [dispatch, currentPage, currentUser]);

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (pagination.totalPages > 0) {
      setCurrentPage(1);
    } else {
      setCurrentPage(0); // no pages available
    }
  }, [pagination.totalPages]);


  return (
    <div className="rounded-md w-full h-[400px] p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
      <div className="flex flex-row justify-between items-center">
        <div className="font-bold text-lg">Leave Request</div>
        <div className="flex justify-between items-center gap-2">
          <Button
            onClick={handlePrev}
            variant={"outline"}
            size={"sm"}
            disabled={currentPage <= 1}
          >
            <ChevronLeft />
          </Button>
          <span className="text-sm text-gray-600">
            Page {currentPage} of {pagination.totalPages}
          </span>
          <Button
            onClick={handleNext}
            disabled={currentPage >= Math.ceil((pagination?.totalElements || 0) / 7)}
            variant={"outline"}
            size={"sm"}
          >
            <ChevronRight />
          </Button>
        </div>
      </div>


      <div className="h-full max-h-full overflow-y-auto">
        <DataTable
          tableMinWidth="500px"
          containerClassname="h-full max-h-full overflow-y-auto relative"
          columns={columns}
          data={requests}
        />
      </div>
    </div>
  );
}

export default StaffLeaveRequestCard;
